import { useEffect } from "react";
import { useLazyGetTagsBasedOnParameterQuery } from "../redux/services";

export const useGetTagsBasedOnCanonicalNames = (canonical_name: string) => {
  const [getTags, tagResponse] = useLazyGetTagsBasedOnParameterQuery();

  const refetch = () => {
    getTags(canonical_name);
  }

  useEffect(() => {
    if (canonical_name) {
      getTags(canonical_name);
    }
    // eslint-disable-next-line
  }, []);

  return { ...tagResponse, options: tagResponse?.data?.tags || [], loading: tagResponse?.isLoading || tagResponse?.isFetching, refetch };
};
